<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content.modal-success
        div.modal-body
          h5.text-center 選擇藥物類別
          div.group-wrapper
            div.group-button(v-for="group in medGroups" @click="selectGroup(group.id)")
              span {{ group.name }}
          div.modal-footer
            button.btn.btn-white(@click="close") 取消
</template>

<script>


export default {
  name: 'MedGroupSelect',
  data() {
    return {
      medGroups: [],
    };
  },
  created() {
    this.getMedGroups();
  },
  mounted() {
    //
  },
  methods: {
    close() {
      this.$store.commit('SHOW_MODAL', { modalName: 'medGroupSelect', status: false });
    },
    getMedGroups() {
      this.instance.get('/api/medication-group/')
      .then((res) => {
        this.medGroups = res.data;
      });
    },
    selectGroup(id) {
      this.$emit('setGroup', id);
      this.close();
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
};
</script>

<style lang="sass">
.group-wrapper
  padding: 2rem 0
  display: flex
  flex-direction: row
  width: 100%
  justify-content: space-around;

  .group-button
    width: 90px
    height: 90px
    background-color: white
    color: #42b883
    display: inline-flex
    align-items: center
    justify-content: center
    border-radius: 0.25rem
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
    &:active
      box-shadow: inset 0 0 20px #000000;
.btn-white
  background: transparent
  color: white
  &:active
    background-color: white
    color: gray
</style>






// WEBPACK FOOTER //
// MedicineGroupSelect.vue?5549254c